module.exports = __webpack_public_path__ + "assets/img/send_24px.d8dcd62c.svg";